import React from 'react';
import { IconProps } from './types';

export const WhatsappIcon: React.FC<IconProps> = props => {
  const { className, height = 12, width = 12, fillColor = '#00BA34', onClick } = props;
  return (
    <svg width={width} height={height} fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#a)">
        <path
          d="M6 .045A6 6 0 0 0 0 6a5.865 5.865 0 0 0 1.07 3.385l-.68 2a.255.255 0 0 0 .06.255.25.25 0 0 0 .255.06l2.095-.665A5.969 5.969 0 1 0 6 .045Zm3.6 8.36A1.95 1.95 0 0 1 7.85 9.45a5.405 5.405 0 0 1-1.73-.5 6.94 6.94 0 0 1-2.97-2.58c-.96-1.265-1-2.45-.085-3.43a1.105 1.105 0 0 1 .96-.28.765.765 0 0 1 .6.44l.195.46.315.755a.55.55 0 0 1 0 .5 2.595 2.595 0 0 1-.5.685c.26.388.562.747.9 1.07a4.5 4.5 0 0 0 1.365.82c.14-.185.41-.5.5-.64a.5.5 0 0 1 .67-.175c.19.065 1.255.59 1.255.59.136.044.255.13.34.245a1 1 0 0 1-.065.995Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h12v12H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
